import * as React from 'react';

import * as styles from './LocationModalContent.css';

export const LocationModalContent = React.forwardRef<HTMLDivElement, React.PropsWithChildren<{}>>((props, ref) => {
  return (
    <div className={styles['content-wrapper']} ref={ref}>
      <ul role="listbox" className={styles['list']}>
        {props.children}
      </ul>
    </div>
  );
});

LocationModalContent.displayName = 'LocationModalContent';
